import { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1, purple1, purple8 } from 'approot/shared/styles/colours.style';
import {
  spacing8,
  spacing12,
  spacing16,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import {
  StandardInputProps,
  standardInputStyles,
} from 'approot/shared/styles/inputs.style';
import {
  borderRadius16,
  borderRadius8,
  boxShadowBlack12,
} from 'approot/shared/styles/borders.style';
import searchIcon from 'approot/shared/icons/icon_search.svg';

export type BaseAutosuggestStylesProps = {
  $itemClassName: string;
  $descriptionClassName?: string;
};

const hoverStyles = css<BaseAutosuggestStylesProps>`
  background-color: ${purple1};
  cursor: pointer;

  ${props => props.$itemClassName},
  ${props => props.$descriptionClassName} {
    color: ${purple8};
  }
`;

export const baseAutosuggestStyles = css<
  BaseAutosuggestStylesProps & StandardInputProps
>`
  .autosuggest_inputbox {
    ${standardInputStyles}
    box-shadow: none;
    padding-left: ${rem(spacing40)};
    background: url(${searchIcon}) no-repeat left ${rem(spacing16)} center;
    background-size: ${rem(14)};
    border-radius: ${rem(40)};
    width: 100%;
  }

  input[type='search']::-ms-clear {
    display: none;
  }
  input[type='search']::-ms-reveal {
    display: none;
  }

  input[type='search']::-webkit-search-decoration,
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-button,
  input[type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .autosuggest_suggestions_container {
    ${boxShadowBlack12}

    background-color: ${grey1};
    width: 100%;
    display: block;
    position: absolute;
    z-index: 9;
    max-height: ${rem(300)};
    overflow-y: scroll;
    margin-top: ${rem(2)};
    border-radius: ${rem(borderRadius16)};
  }

  .autosuggest_suggestion__item--highlighted {
    ${hoverStyles}
  }

  .autosuggest_suggestions_list {
    background-color: ${grey1};
    list-style-type: none;
    padding: ${rem(spacing12)};
    margin: 0;
  }

  .autosuggest_suggestion__item {
    padding: ${rem(spacing8)} ${rem(spacing12)};
    border-radius: ${rem(borderRadius8)};

    &:hover {
      ${hoverStyles}
    }
  }
`;
